import { Component } from '@angular/core';
import { ToastService } from '@app/services/toast.service';
import { AuthServiceService } from '@app/services/auth-service.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent {
  constructor(
    public toastService: ToastService,
    private authService: AuthServiceService
  ) {}

  get isAuthPage(): boolean {
    // If not logged in, we assume it's the auth/login container state
    return localStorage.getItem('isLoggedIn') !== 'true';
  }

  get toasts() {
    return this.toastService.toasts;
  }

  dismiss(id: string) {
    this.toastService.dismiss(id);
  }
}
